import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './Billing.scss'
import { Box, Grid, Table, TableBody, TableCell, TableHead, TableRow, Typography, Checkbox } from '@mui/material';
import Plan from '../../../assets/Images/plan.png';
import { MdDataUsage } from "react-icons/md";
import { BsPersonUp } from "react-icons/bs";
import { MdPerson } from "react-icons/md";
import { MdEmail } from "react-icons/md";
import Swal from "sweetalert2";
import BillingIcon from '../../../assets/Images/Billing.png'
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { FaMessage } from "react-icons/fa6";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { RiShareForwardFill } from "react-icons/ri";
import axios from 'axios';

const Billing = () => {

  const [role, setRole] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [isOpenShare, setIsOpenShare] = useState(false);

  //credits count
  const [credits, setCredits] = useState(0);
  const [spentCredits, setSpentCredits] = useState(0);
  const [remainingCredits, setRemainingCredits] = useState(0);
  const [billingDate, setBillingDate] = useState();
  const [pricing, setPricing] = useState(0);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [attachment, setAttachment] = useState();

  const [details, setDetails] = useState(null);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;


  const [accountOwnerDetails, setAccountOwnerDetails] = useState(null);

  const { id } = useParams();
  
  useEffect(() => {
    const userRole = localStorage.getItem('role');
    const name = localStorage.getItem('name');
    const email = localStorage.getItem('email');
    setRole(userRole);
    setName(name.toUpperCase());
    setEmail(email);
  }, []);

  useEffect(() => {
    if (role === 'user') {
      fetchUsers();
      fetchAccountOwnerDetails();
    } else if (role === 'admin') {
      fetchUserBilling();
      fetchAdminAccountOwnerDetails();
    }
  }, [role, id]);


  const fetchAccountOwnerDetails = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${baseURL}/api/account-owner`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.accountOwnerDetails && Array.isArray(response.data.accountOwnerDetails)) {
        const ownerDetails = response?.data?.accountOwnerDetails[0];
        setAccountOwnerDetails(ownerDetails?.primaryContact);
        setDetails(ownerDetails);
      }
    } catch (err) {
      console.error("Error fetching account owner details:", err);
      setError("Failed to load details.");
    }
  };

  const fetchAdminAccountOwnerDetails = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${baseURL}/api/account-owner/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.accountOwnerDetails && Array.isArray(response.data.accountOwnerDetails)) {
        const ownerDetails = response?.data?.accountOwnerDetails[0];
        setAccountOwnerDetails(ownerDetails?.primaryContact);
        setDetails(ownerDetails);
      }
    } catch (err) {
      console.error("Error fetching account owner details:", err);
      setError("Failed to load details.");
    }
  };

  const fetchUsers = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found. User is not authenticated.");
      return;
    }

    const apiUrl = `${baseURL}/api/user`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch user data`);
      }

      const data = await response.json();

      if (!data || typeof data !== 'object') {
        throw new Error("Unexpected response format: Expected an object");
      }

      if (data.details && Array.isArray(data.details)) {
        setCredits(data?.subscriptions[0].credits);
        setSpentCredits(data.subscriptions[0].spentcredits);
        setRemainingCredits(data.subscriptions[0].remainingcredits);
        setBillingDate(new Date(data.subscriptions[0].endDate).toLocaleDateString('en-GB'))
        setPricing(data.subscriptions[0].charges);
      } else {
        console.error("Details is missing or not an array");
      }
    } catch (error) {
      Swal.fire({
        icon: "info",
        title: "Subscribe",
        text: "Please subscribe to view billing and payments.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
      return navigate('/subscription');
    }
  };

  const fetchUserBilling = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("No token found. User is not authenticated.");
      return;
    }
    const apiUrl = `${baseURL}/api/admin-user-billing/${id}`;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch user data (Status: ${response.status})`);
      }

      const data = await response.json();

      if (!data || typeof data !== 'object') {
        throw new Error("Unexpected response format: Expected an object");
      }

      if (data.details && Array.isArray(data.details)) {
        setCredits(data.subscriptions[0].credits);
        setSpentCredits(data.subscriptions[0].spentcredits);
        setRemainingCredits(data.subscriptions[0].remainingcredits);
        setBillingDate(new Date(data.subscriptions[0].endDate).toLocaleDateString('en-GB'))
        setPricing(data.subscriptions[0].charges);
      } else {
        console.error("details is missing or not an array");
      }

    } catch (error) {
      Swal.fire({
        icon: "warm",
        text: "User not subscribed",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      });
    }
  };

  const invoices = [
    {
      id: 'INV01',
      invoiceDate: '2022-11-30',
      dueDate: '2025-12-20',
      status: 'Paid',
      total: '$358',
    },
    {
      id: 'INV02',
      invoiceDate: '2023-01-15',
      dueDate: '2025-10-10',
      status: 'Unpaid',
      total: '$400',
    },
  ];



  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = invoices.map((inv) => inv.id);
      setSelectedInvoices(allIds);
    } else {
      setSelectedInvoices([]);
    }
  };

  const handleCheckboxChange = (invoiceId) => {
    setSelectedInvoices((prevSelected) =>
      prevSelected.includes(invoiceId)
        ? prevSelected.filter((id) => id !== invoiceId)
        : [...prevSelected, invoiceId]
    );
  };

  const handleDownloadPdf = () => {
    if (selectedInvoices.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select at least one row to download.",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "Ok",
      });
      return;
    }
    const doc = new jsPDF();

    doc.text('Invoice Report', 14, 20);

    const tableColumn = ['Invoice', 'Invoice Date', 'Due Date', 'Status', 'Total'];
    const tableRows = [];

    // Only include selected invoices
    const selected = invoices.filter(invoice => selectedInvoices.includes(invoice.id));

    selected.forEach(invoice => {
      const invoiceData = [
        invoice.id,
        invoice.invoiceDate,
        invoice.dueDate,
        invoice.status,
        invoice.total
      ];
      tableRows.push(invoiceData);
    });

    if (tableRows.length === 0) {
      Swal.fire({
        icon:'warning',
        title: 'No invoices selected to download'
      })
      return;
    }

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
    });

    doc.save('selected_invoice_report.pdf');
    setSelectedInvoices([]);
  };

  const handleOpenShare = async () => {
    if (selectedInvoices.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Please select at least one invoice",
        confirmButtonColor: "#FCB124",
      });
      return;
    }

    const selected = invoices.filter(inv => selectedInvoices.includes(inv.id));

    const doc = new jsPDF();
    doc.text('Selected Invoice Report', 14, 20);

    const tableColumn = ['Invoice', 'Invoice Date', 'Due Date', 'Status', 'Total'];
    const tableRows = [];

    selected.forEach(invoice => {
      tableRows.push([
        invoice.id,
        invoice.invoiceDate,
        invoice.dueDate,
        invoice.status,
        invoice.total
      ]);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30,
    });

    const pdfBlob = doc.output('blob');
    const file = new File([pdfBlob], 'selected_invoices.pdf', { type: 'application/pdf' });

    setAttachment(file);
    setIsOpenShare(true);
  };


  const handleShareInvoice = async () => {
    if (!attachment || !email) return;

    const formData = new FormData();
    formData.append('file', attachment);
    formData.append('to', email);
    formData.append('invoiceId', 'Selected Invoices');

    console.log("Sending the following data:", formData);

    try {
      await fetch(`${baseURL}/api/send-invoice`, {
        method: 'POST',
        body: formData,
      });

      Swal.fire({
        icon: "success",
        title: "Selected invoices shared successfully",
        confirmButtonColor: "#FCB124",
      });

      setIsOpenShare(false);
      setSelectedInvoices([]);
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to send invoices",
        confirmButtonColor: "#FCB124",
      });
      console.error(err);
    }
  };


  return (
    <Box className='billing-container' >
      <div className='billing-top'>
        <img src={BillingIcon} alt='billing' />
        <p>Billing</p>
      </div>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className='billing-item'>
              <div className='plan-img'>
                <img className='plan-picture' alt='plan' src={Plan} />
                <p className='plan'>Plan Details</p>
              </div>
              <div className='billing-plan'>
                <p>Basic</p>
                <p>Billed Monthly</p>
              </div>
              <div className='billing-flex'>
                <div>
                  <div className='billing-row'>
                    <div className='billing-date'>
                      <p>Billing Date</p>
                      <p>Pricing</p>
                    </div>
                    <div className='billing-dash'>
                      <p>-</p>
                      <p>-</p>
                    </div>
                    <div className='billing-price'>
                      <p>{billingDate}</p>
                      <p className='price'>{pricing}</p>
                    </div>
                  </div>
                </div>
                <div className='billing-button' style={{ marginTop: '10px' }}>
                  <button>Renew</button>
                  <button>Explore</button>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className='billing-item'>
              <div className='owner-img'>
                <BsPersonUp className='owner-picture' />
                <p className='plan'>Account Owner</p>
              </div>
              <div className='account-plan'>
                <div className='owner-name'>
                  <MdPerson />
                  <p>Name</p>
                </div>
                <div className='owner-name'>
                  <span></span>
                  &nbsp;&nbsp;<span>
                    {accountOwnerDetails && accountOwnerDetails.name
                      ? accountOwnerDetails.name
                      : name}
                  </span>
                </div>
              </div>
              <div className='account-plan'>
                <div className='owner-name'>
                  <MdEmail />
                  <p>Email</p>
                </div>
                <div className='owner-name'>
                  <span></span>
                  &nbsp;&nbsp; <span>
                    {accountOwnerDetails && accountOwnerDetails.email
                      ? accountOwnerDetails.email
                      : email}
                  </span>
                </div>
                <div className='billing-button'>
                  <button onClick={() => navigate('/accountowner')}>Update</button>
                </div>
              </div>
            </div>

          </Grid>
          <Grid item xs={12}>
            <div className='billing-item'>
              <div className='plan-img'>
                <MdDataUsage className='plan-picture' />
                <p className='plan'>Usage</p>
              </div>
              <div className='subscribe-plan'>
                <div className='total-credits'>
                  <p>Total credits</p>
                  <p>Spent credits</p>
                  <p>Remaining credits</p>
                </div>
                <div className='spent-credits'>
                  <p>{credits}</p>
                  <p>{spentCredits}</p>
                  <p>{remainingCredits}</p>
                </div>

              </div>
              <div style={{ marginTop: '30px' }} className='billing-button'>
                <button>Expand</button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className='invoice'>
        <div className='invoice-title'>
          <div className='invoice-logo'>
            <FaFileInvoiceDollar />
            <Typography className='invoice-typo'>Invoice History</Typography>
          </div>
          <div className='invoice-logo'>
            <p onClick={handleDownloadPdf} className='download-invoice'>Download</p>
            <p className='download-invoice' onClick={handleOpenShare}>share</p>
          </div>
        </div>
        <div className='invoice-table'>
          <Table>
            <TableHead className='invoice-head'>
              <TableRow className='invoice-head-row'>
                <TableCell>
                  <Checkbox
                    checked={selectedInvoices.length === invoices.length}
                    onChange={handleSelectAll}
                    sx={{ width: '5px', height: '5px' }}
                    inputProps={{ 'aria-label': 'select all invoices' }}
                  />

                </TableCell>
                <TableCell className='invoice-head-cell'>Invoice</TableCell>
                <TableCell className='invoice-head-cell'>Invoice Date</TableCell>
                <TableCell className='invoice-head-cell'>Due Date</TableCell>
                <TableCell className='invoice-head-cell'>Status</TableCell>
                <TableCell className='invoice-head-cell'>Total</TableCell>
                <TableCell className='invoice-head-cell'>Payment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoices.map((invoice, index) => (
                <TableRow key={index} className='invoice-body-row'>
                  <TableCell>
                    <Checkbox
                      checked={selectedInvoices.includes(invoice.id)}
                      onChange={() => handleCheckboxChange(invoice.id)}
                      sx={{ width: '5px', height: '5px', marginLeft: '3px' }}
                      inputProps={{ 'aria-label': `select invoice ${invoice.id}` }}
                    />
                  </TableCell>
                  <TableCell className='invoice-body-invoice'>{invoice.id}</TableCell>
                  <TableCell>{invoice.invoiceDate}</TableCell>
                  <TableCell>{invoice.dueDate}</TableCell>
                  <TableCell className='invoice-body-paid'>{invoice.status}</TableCell>
                  <TableCell>{invoice.total}</TableCell>
                  <TableCell >Pay now</TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </div>
        <div className='invoice-message'>
          <div className='invoice-svg'>
            <FaMessage />
          </div>
        </div>
      </div>


      {isOpenShare && (
        <div className='share-popup'>
          <div className='overlay' onClick={() => setIsOpenShare(false)}></div>
          <div className='share-popup-box'>
            <div className='share-invoice-flex'>
              <p className='share-txt'>SHARE</p>
              <p onClick={() => setIsOpenShare(false)} style={{ cursor: 'pointer' }}>X</p>
            </div>

            <hr />

            <div className='share-invoice'>
              {/* Loop through selected invoices and display the relevant details */}
              {selectedInvoices.map((invoiceId) => {
                const invoice = invoices.find((inv) => inv.id === invoiceId);
                return (
                  <div className='invoice-loop' key={invoice.id}>
                    <p>Invoice no - {invoice.id}</p>
                    <p>Invoice date - {invoice.invoiceDate}</p>
                  </div>
                );
              })}
            </div>

            <div className='mail-invoice'>
              <p>To</p>
              <input
                className='invoice-input'
                type='email'
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className='attachment-invoice'>
              <p>Attachment</p>
              {attachment ? (
                <p style={{ fontSize: '14px' }}>{attachment.name}</p>
              ) : (
                <p style={{ fontSize: '14px', color: 'red' }}>No attachment found</p>
              )}
              <textarea placeholder='Message (optional)' />
            </div>

            <div className='share-btn'>
              <button onClick={handleShareInvoice}>SHARE</button>
            </div>
          </div>
        </div>
      )}


    </Box>
  );
};

export default Billing;